import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Filter = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.74 21.99C10.08 21.99 9.55 21.4403 9.55 20.7606V12.6247C5.39 11.5452 2.31 7.77711 2 3.31934C2 2.54973 2.53 2 3.19 2H20.81C21.54 2.04998 22.04 2.62969 22 3.30935C21.69 7.77711 18.61 11.5352 14.45 12.6247V18.5817C14.45 18.9515 14.29 19.2914 14.02 19.5312L11.5 21.7101C11.29 21.8901 11.02 22 10.74 22V21.99ZM3.19 3.15942C3.19 3.15942 3.12 3.18941 3.12 3.22939C3.41 7.33733 6.32 10.7756 10.22 11.5952C10.48 11.6552 10.67 11.8851 10.67 12.1649V20.7606C10.67 20.7606 10.7 20.8306 10.74 20.8306L13.31 18.6417L13.34 12.1649C13.34 11.8851 13.53 11.6552 13.79 11.5952C17.69 10.7756 20.61 7.33733 20.89 3.22939C20.89 3.18941 20.86 3.14943 20.82 3.14943H3.19V3.15942Z" />
  </svg>
)

export default withDefaultStyles(Filter)
